module.exports = __webpack_public_path__ + "static/media/AfghanPeople.d1bf6c23.svg";